import { ReactNode } from "react";
import { useAppContext } from "@/src/config/AppProvider";
import ClassicBanner from "./Classic/ClassicBanner";
import SliderBanner from "./Slider/SliderBanner";

const BannerSection = (): ReactNode => {
  const { licenceSettings } = useAppContext();

  if (licenceSettings.IsSliderActive) return <SliderBanner />;

  return <ClassicBanner />;
};

export default BannerSection;
